import { createColumnHelper } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import useTable from 'components/table/hooks/useTable';
import { SystemTemplatesTableStyled } from '../../SystemTemplatesTab.styles';
import { SystemTemplateRow } from '../../SystemTemplatesTab.types';
import ActionsCell from './cells/ActionsCell';
import StatusCell from './cells/StatusCell';

interface SystemTemplatesTableProps {
  'data-testid': string;
  data: SystemTemplateRow[];
}

const SystemTemplatesTable = ({
  data,
  ...props
}: SystemTemplatesTableProps) => {
  const { t } = useTranslation();
  const columnHelper = createColumnHelper<SystemTemplateRow>();

  const columns = [
    columnHelper.accessor(
      (row) =>
        t('pageAutomations.systemTemplates.systemTemplateName', {
          context: row.key,
        }),
      {
        id: 'name',
        header: t('common.name'),
        sortDescFirst: true,
      },
    ),
    columnHelper.accessor(
      (row) =>
        t('pageAutomations.systemTemplates.systemTemplateDescription', {
          context: row.key,
        }),
      {
        id: 'description',
        header: t('common.description'),
        enableSorting: false,
      },
    ),
    columnHelper.display({
      id: 'actions',
      header: t('common.actions'),
      cell: ActionsCell,
      meta: {
        showCellTooltip: false,
      },
    }),
    columnHelper.accessor('defaultStatus', {
      id: 'status',
      header: t('common.status'),
      cell: StatusCell,
      enableSorting: false,
      meta: {
        showCellTooltip: false,
      },
    }),
  ];

  const tableInstance = useTable({
    data,
    columns,
    manualPagination: true,
    pageCount: 1,
  });

  return (
    <SystemTemplatesTableStyled tableInstance={tableInstance} {...props} />
  );
};

export default SystemTemplatesTable;
